import type { ReactNode } from "react";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import { useAutoSilentSignIn } from "pymble-ui/components";
import { api_s2 } from "../config";
import { AutoSignInStatusContext } from "../hooks/useAutoSignInStatus";

function signInDestination(pathname: string): "/groups" | "/presets" {
  return pathname.startsWith("/presets") ? "/presets" : "/groups";
}

export default function AutoSignInProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { instance, inProgress, accounts } = useMsal();
  const location = useLocation();
  const { status } = useAutoSilentSignIn({
    instance,
    inProgress,
    accounts,
    scopes: api_s2.scopes,
    redirectStartPage: signInDestination(location.pathname),
  });

  return (
    <AutoSignInStatusContext.Provider value={status}>
      {children}
    </AutoSignInStatusContext.Provider>
  );
}
